<p-is-zs-toggle class="zs-toggle-component zs-display-inline" [ngClass]="{'toggle-button': isDisabled}"
  [name]="toggleId + elementId" 
  [active]="isActive"
  (change)="onclick()">
</p-is-zs-toggle>